export default __webpack_public_path__ + "media/img/list-cards-bg-cae19afb0c2a5e299488ddb0d3fe884a.svg";